import React, { FC, ReactElement, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { StyleSheetManager } from 'styled-components'
import MainComponent from 'components/MainComponent'
import DevTools from 'DevTools'
import tenants from 'Constants/tenants'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'

const App: FC<MicroFrontendProps> = (microFrontendProps): ReactElement => {
  const [ref, setRef] = useState<HTMLDivElement | null>(null)
  const styleRef = useRef<HTMLLinkElement | null>(null)
  const [cssIsInjected, setCssIsInjected] = useState(false)

  const cache = createCache({
    key: 'shadow-dom-css',
    prepend: true,
    container: ref as Node,
    speedy: false,
  })

  if (styleRef.current) {
    styleRef.current.onload = () => {
      setCssIsInjected(true)
    }
    styleRef.current.onerror = () => {
      // if we don't have any css file (if you use styled components)
      setCssIsInjected(true)
    }
  }

  return (
    <div id='root' ref={setRef}>
      <link
        ref={styleRef}
        rel='stylesheet'
        href={
          process.env.REACT_APP_DEPLOY_PATH
            ? process.env.REACT_APP_DEPLOY_PATH + '/static/css/main.css'
            : 'static/css/main.css'
        }
      />
      {ref && cssIsInjected && (
        <div id='app'>
          <CacheProvider value={cache}>
            <StyleSheetManager target={ref}>
              <MainComponent {...microFrontendProps} />
            </StyleSheetManager>
          </CacheProvider>
        </div>
      )}
    </div>
  )
}
export default App
if (window.document.title === 'TA-Interaktiv Microfrontend') {
  const DevToolAppWrapper: FC = (): ReactElement => {
    const [isDarkmode, setIsDarkmode] = useState(false)
    const [currentTenantKey, setCurrentTenantKey] =
      useState<TenantKey>('tagesanzeiger')
    return (
      <DevTools
        setTenant={setCurrentTenantKey}
        setIsDarkmode={setIsDarkmode}
        isDarkmode={isDarkmode}
        currentTenantKey={currentTenantKey}
      >
        <>
          {process.env.NODE_ENV === 'development' && (
            <div style={{ height: '10vh', background: '#f2f4f6' }} />
          )}
          <App
            tenant={
              tenants.find(
                (tenant) => tenant.key === currentTenantKey
              ) as Tenant
            }
            colorMode={isDarkmode ? 'dark' : 'light'}
          />
          {process.env.NODE_ENV === 'development' && (
            <div style={{ height: '10vh', background: '#f2f4f6' }} />
          )}
        </>
      </DevTools>
    )
  }
  const root = createRoot(document.getElementById('root')!)
  root.render(
    <React.StrictMode>
      <DevToolAppWrapper />
    </React.StrictMode>
  )
}
